import { createGlobalStyle } from 'styled-components'

export const GlobalStyle = createGlobalStyle`
.off-icon {
  color: #D8D8D8;
}
`
